import React from 'react'
import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {StartFreeToday} from '../../../pages/landing/components/StartFreeToday'
import {ShippingCostCalculator} from './ShippingCostCalculator'
import {AddressRateTools} from './tools/AddressRateTools'
import {ROUTES} from '../../../../_gori/constants/_routes'

export function ShippingCalculators() {
  const intl = useIntl()

  return (
    <div className='shipping-calculators-page bg-light'>
      {/* Hero Section */}
      <section className='d-flex shipping-calc__hero align-self-stretch py-30 shipping-calc__hero-bg align-items-center text-center flex-column'>
        <h1 className='shipping-calc__hero-title shipping-calc__title text-center mb-0'>
          {intl.formatMessage({id: 'SHIPPING_CALCULATORS'})}
        </h1>
        <p className='shipping-calc__hero-subtitle lh-normal fw-bold text-center mb-0 w-100 px-4'>
          {intl.formatMessage({id: 'ESTIMATE_SHIPPING_COSTS_EASILY'})}
        </p>
        <Link
          to={ROUTES.AUTH.REGISTRATION}
          className='desktop-only btn btn-primary hover-orange rounded-pill text-center d-block w-fit-content mx-auto mb-12px ps-10 pe-10 text-white custom-button'
        >
          {intl.formatMessage({id: 'EXPLORE_SHIPBAE'})}
        </Link>
      </section>

      {/* Shipping Cost Calculator */}
      <section
        className='shipping-calc__section py-30 bg-white'
        aria-label={intl.formatMessage({id: 'CALCULATE_YOUR_SHIPPING_COSTS'})}
      >
        <div className='d-flex flex-column justify-content-center align-items-center gap-18 shipping-calc__section-width mx-auto px-4'>
          <div className='d-flex flex-column align-items-center gap-7 w-100'>
            <h2 className='shipping-calc__heading lh-normal shipping-calc__title text-dark text-center'>
              {intl.formatMessage({id: 'CALCULATE_YOUR_SHIPPING_COSTS'})}
            </h2>
            <p className='shipping-calc__subtitle fs-2 fw-bold text-center mb-0'>
              {intl.formatMessage({id: 'SHIPPING_RATES_SUBJECT_TO_CHANGE'})}
            </p>
          </div>
          <ShippingCostCalculator />
        </div>
      </section>

      {/* Address & Rate Accuracy Tools */}
      <AddressRateTools />

      <StartFreeToday />
    </div>
  )
}
